module.exports = __webpack_public_path__ + "static/media/cavaliers.66469b7e.jpeg";